import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

import { ReactComponent as AddFilterSvg } from './svg/add-filter.svg';
import { ReactComponent as Agent2KSvg } from './svg/agent2k.svg';
import { ReactComponent as Agent3KSvg } from './svg/agent3k.svg';
import { ReactComponent as Agent3KGSvg } from './svg/agent3kg.svg';
import { ReactComponent as Agent4KSvg } from './svg/agent4k.svg';
import { ReactComponent as Agent4KWSvg } from './svg/agent4kw.svg';
import { ReactComponent as AutoRefreshSvg } from './svg/autorefresh.svg';
import { ReactComponent as CheckCircleOffSvg } from './svg/check-circle-off.svg';
import { ReactComponent as ComparisonPeriodSvg } from './svg/comparison-period.svg';
import { ReactComponent as ComparisonPeriodAfterSvg } from './svg/comparison-period-after.svg';
import { ReactComponent as ComparisonPeriodBeforeSvg } from './svg/comparison-period-before.svg';
import { ReactComponent as ContentCopySvg } from './svg/content-copy.svg';
import { ReactComponent as DockerSvg } from './svg/docker.svg';
import { ReactComponent as JumpReportingSvg } from './svg/jump-reporting.svg';
import { ReactComponent as JumpSettingsSvg } from './svg/jump-settings.svg';
import { ReactComponent as LinuxSvg } from './svg/linux.svg';
import { ReactComponent as NetworkDeviceSvg } from './svg/network-device.svg';
import { ReactComponent as PathEllipsisSvg } from './svg/path-ellipsis.svg';
import { ReactComponent as PlcSvg } from './svg/plc.svg';
import { ReactComponent as ISNGSvg } from './svg/isng.svg';
import { ReactComponent as PlmSvg } from './svg/plm.svg';
import { ReactComponent as RefreshSvg } from './svg/refresh.svg';
import { ReactComponent as TestAgentSvg } from './svg/testagent.svg';
import { ReactComponent as VmwareHypervisorSvg } from './svg/vmware-hypervisor.svg';
import { ReactComponent as VmwareVmSvg } from './svg/vmware-vm.svg';
import { ReactComponent as WindowsSvg } from './svg/windows.svg';
import { ReactComponent as Ng1UniversalMonitorSvg } from './svg/ng1-universal-monitor.svg';

export const AddFilter = makeSvgIcon(AddFilterSvg);
export const NPoint2K = makeSvgIcon(Agent2KSvg, 24);
export const NPoint3K = makeSvgIcon(Agent3KSvg, 24);
export const NPoint4K = makeSvgIcon(Agent4KSvg, 24);
export const NPoint4KW = makeSvgIcon(Agent4KWSvg, 24);
export const NPoint3KG = makeSvgIcon(Agent3KGSvg, 24);
export const AutoRefresh = makeSvgIcon(AutoRefreshSvg);
export const CheckCircleOff = makeSvgIcon(CheckCircleOffSvg);
export const ComparisonPeriod = makeSvgIcon(ComparisonPeriodSvg);
export const ComparisonPeriodAfter = makeSvgIcon(ComparisonPeriodAfterSvg);
export const ComparisonPeriodBefore = makeSvgIcon(ComparisonPeriodBeforeSvg);
export const ContentCopy = makeSvgIcon(ContentCopySvg);
export const Docker = makeSvgIcon(DockerSvg, 24);
export const JumpReporting = makeSvgIcon(JumpReportingSvg);
export const JumpSettings = makeSvgIcon(JumpSettingsSvg);
export const Linux = makeSvgIcon(LinuxSvg);
export const NetworkDevice = makeSvgIcon(NetworkDeviceSvg);
export const PathEllipsis = makeSvgIcon(PathEllipsisSvg);
export const Plc = makeSvgIcon(PlcSvg);
export const ISNG = makeSvgIcon(ISNGSvg);
export const Plm = makeSvgIcon(PlmSvg);
export const Refresh = makeSvgIcon(RefreshSvg);
export const TestAgent = makeSvgIcon(TestAgentSvg);
export const VmwareHypervisor = makeSvgIcon(VmwareHypervisorSvg);
export const VmwareVm = makeSvgIcon(VmwareVmSvg);
export const Windows = makeSvgIcon(WindowsSvg, 24);
export const Ng1UniversalMonitor = makeSvgIcon(Ng1UniversalMonitorSvg, 24);

function makeSvgIcon(iconCmp, viewBox = 48) {
    const fn = (props) => {
        const { fontSize } = props;

        return <SvgIcon component={iconCmp} fontSize={fontSize} viewBox={`0 0 ${viewBox} ${viewBox}`} />;
    };

    fn.propTypes = {
        fontSize: PropTypes.oneOf(['default', 'inherit', 'small', 'large']),
    };

    fn.defaultProps = {
        fontSize: undefined,
    };

    return fn;
}

export function ColoredPlmStatus(props) {
    const { accentColor } = props;
    return (
        <SvgIcon viewBox="0 0 48 48">
            <g>
                <path d="M 17.089 2.521 C 20.922 -0.342 27.092 -0.342 30.925 2.521 L 33.951 4.782 L 23.837 12.34 L 19.946 9.432 L 16.801 23.412 L 35.511 21.062 L 31.62 18.155 L 41.734 10.597 L 44.761 12.859 C 48.593 15.722 48.593 20.333 44.761 23.196 L 42.05 25.222 C 40.203 24.109 38.038 23.469 35.723 23.469 C 28.974 23.469 23.504 28.929 23.469 35.67 C 21.151 35.575 18.868 34.863 17.089 33.534 L 3.253 23.196 C -0.579 20.333 -0.579 15.722 3.253 12.859 L 17.089 2.521 Z M 3.253 27.434 L 17.089 37.771 C 19.055 39.24 21.635 39.955 24.2 39.918 C 25.15 42.538 26.967 44.743 29.304 46.185 C 25.512 48.019 20.419 47.692 17.089 45.205 L 3.253 34.867 C 0.016 32.449 -0.476 28.788 1.755 25.982 C 2.165 26.498 2.658 26.989 3.253 27.434 Z M 44.761 27.434 C 45.356 26.989 45.849 26.498 46.259 25.982 C 47.625 27.7 47.97 29.738 47.29 31.615 C 46.732 30.05 45.864 28.632 44.761 27.434 Z" />
                <path
                    style={{ fill: accentColor }}
                    d="M 48 35.735 C 48 42.505 42.505 48 35.723 48 C 28.952 48 23.469 42.505 23.469 35.735 C 23.469 28.964 28.952 23.469 35.723 23.469 C 42.505 23.469 48 28.964 48 35.735 Z M 33.668 45.233 L 37.833 45.233 L 37.833 41.068 L 33.668 41.068 Z M 33.668 38.833 L 37.833 38.833 L 37.833 26.335 L 33.668 26.335 Z"
                />
            </g>
        </SvgIcon>
    );
}
